import { dqgj } from '@/axios'
let that;
export default{
	data(){
		return{
			time:"",
			title:"",
			content:"",
			url:"",
			img:"",
			u_name:""
		}
	},
	methods:{
		// 获取数据
		getdata(){
			dqgj.dqgjUpdateGet({id:that.$route.query.id}).then(res => {
				that.title = res.data.title!=""?res.data.title:'暂无标题'
				that.content = res.data.content!=""?res.data.content:'暂无数据'
				that.url = res.data.url!=""?res.data.url:'暂无数据';
				that.time = that.$changeTime(res.data.addtime);
				that.img = res.data.sz_img!=""?res.data.sz_img.search("http")!=-1?res.data.sz_img:'http://'+res.data.ym+'/'+res.data.sz_img:'暂无数据'
			})
		},
		// 编辑
		goedit(){
			//编辑/新增
			that.$router.push({
				path:'/ywfz_add',
				query:{
					id:that.$route.query.id,
					flag:that.$route.query.flag,
					type:'edit',
				},
			})
		}
	},
	mounted() {
		that.getdata();
	},
	created() {
		that = this;
		that.$emit('selectTop',2)
	}
}